import React from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";

// STYLES
import {
  ProjectCardContainer,
  ProjectCardImage,
  TextWrapper,
} from "./ProjectCardStyled";

// LIBRARIES

// MISC
import { IProps, ProjectCardType } from "./ProjectCardModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { useNavigate } from "react-router-dom";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const ProjectCard = (props: IProps) => {
  // PROPERTIES
  const {
    id = 0,
    image = "",
    text = "",
    type = ProjectCardType.PROJECTS_CAROUSEL,
  } = props;
  // LIBRARY CONSTANTS

  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const navigate = useNavigate();

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  return (
    <ProjectCardContainer
      type={type}
      onClick={() => navigate(appRoutes.projectDetails + id)}
    >
      <ProjectCardImage
        src={image ? image : CoverPlaceholder}
        alt={"Project image"}
        biggerCursor={biggerCursor}
      />
      <TextWrapper>
        <CustomText
          text={text ? text : "Proiect"}
          type={TextType.H3}
          color={COLORS.Cultured}
        />
      </TextWrapper>
    </ProjectCardContainer>
  );
};

export default ProjectCard;
